/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common view services/utilities.
 */
'use strict';

angular
  .module('services.view', ['ui.router'])
  /**
   * A factory with common view utilities.
   */
  .factory('viewUtils', function ($state, VIEW_STATES) {
    return {
      // Data object used to lookup configs around views.  Note
      // that views are not tied to Angular states are views outside of the
      // local viewMap.
      viewData: {
        admin: {
          order: 1,
          state: VIEW_STATES.ADMIN_HOME,
          title: 'DASHBOARD',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/dashboard.svg'
        },
        restore: {
          order: 2,
          state: VIEW_STATES.BULK_RESTORE_ENTER,
          title: 'RESTORE',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/restore.svg'
        },
        export: {
          order: 3,
          state: VIEW_STATES.BULK_EXPORT_ENTER,
          title: 'EXPORT',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/export.svg'
        },
        metadataCompare: {
          order: 4,
          state: VIEW_STATES.METADATA_COMPARE_SELECT,
          title: 'COMPARE_METADATA',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/compare.svg'
        },
        activityHistory: {
          order: 5,
          state: VIEW_STATES.LOG_HOME,
          title: 'ACTIVITY',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/active.svg'
        },
        account: {
          order: 6,
          state: VIEW_STATES.ACCOUNT,
          title: 'ACCOUNT_SETTINGS',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/settings.svg'
        }/*,
        restoreReact: {
          order: 7,
          state: VIEW_STATES.RESTORE_REACT,
          title: 'RESTORE_NEW',
          showInTrial: true,
          isBetaFeature: false,
          iconPath: '/images/restore.svg'
        }*/
      },

      // The object used to map the states to the view names in the
      // viewData object.
      viewMap: {
        admin: [VIEW_STATES.ADMIN_HOME],
        restore: [
          VIEW_STATES.BULK_RESTORE_ENTER,
          VIEW_STATES.BULK_RESTORE_CONFIRM_METADATA,
          VIEW_STATES.BULK_RESTORE_SELECT_METADATA,
          VIEW_STATES.BULK_RESTORE_SELECT_OBJECT,
          VIEW_STATES.BULK_RESTORE_SELECT_DEST,
          VIEW_STATES.BULK_RESTORE_SELECT_CSV,
          VIEW_STATES.BULK_RESTORE_SETTINGS,
          VIEW_STATES.BULK_RESTORE_UPLOAD_CSV,
          VIEW_STATES.BULK_RESTORE_CONFIRM_OBJECT
        ],
        export: [
          VIEW_STATES.BULK_EXPORT_ENTER,
          VIEW_STATES.BULK_EXPORT_SELECT_OBJECT,
          VIEW_STATES.BULK_EXPORT_SELECT_DEST,
          VIEW_STATES.BULK_EXPORT_SELECT_CSV,
          VIEW_STATES.BULK_EXPORT_UPLOAD_CSV,
          VIEW_STATES.BULK_EXPORT_SETTINGS,
          VIEW_STATES.BULK_EXPORT_CONFIRM_OBJECT
        ],
        activityHistory: [
          VIEW_STATES.LOG_HOME,
          VIEW_STATES.BATCH_HOME,
          VIEW_STATES.BATCH_EXPORT,
          VIEW_STATES.BATCH_OBJECT_RESTORE,
          VIEW_STATES.BATCH_BULK_RESTORE,
          VIEW_STATES.BATCH_METADATA_RESTORE,
          VIEW_STATES.BATCH_GDPR_REQUEST
        ],
        account: [VIEW_STATES.ACCOUNT, VIEW_STATES.RECEIPTS_CONTENT_LIST, VIEW_STATES.RECEIPTS_CONTENT_RECEIPT],
        metadataCompare: [
          VIEW_STATES.METADATA_COMPARE_SELECT,
          VIEW_STATES.METADATA_COMPARE_SELECT_COMP_TYPES,
          VIEW_STATES.METADATA_COMPARE_RESULTS
        ],
        restoreReact: [VIEW_STATES.RESTORE_REACT]
      },

      /**
       * Used to transition to a new view.  It will track the previous state associated with
       * each view so that the app can return to the previous state if the user navigates back.
       * to a previously rendered view.
       *
       * @param {String} toState - The state to transition to.  If the state is unknown it will default to the
       *  adminMain.admin view.
       * @param {Object} [currentStateParams] - The state params that were used to load the current state.
       */
      go: function (toState, currentStateParams) {
        var current = $state.current.name,
          toViewDataObj,
          toStateParams;
        this.viewData[this.getViewKey(current)].previous = current;
        this.viewData[this.getViewKey(current)].previousParams = angular.copy(currentStateParams || {});
        toViewDataObj = this.viewData[this.getViewKey(toState)];
        toState = toViewDataObj.previous || toState;
        toStateParams = toViewDataObj.previousParams || {};

        $state.go(toState, toStateParams);
      },

      /**
       * Utility for getting the view object for a state.
       *
       * @param {String} state - The state.
       * @returns {Object} The data object for the view associated with the view.
       */
      getViewObject: function (state) {
        return this.viewData[this.getViewKey(state)];
      },

      /**
       * Utility fused for finding the key in the data object for the state. Defaults to the
       * admin view.
       *
       * @param {String} state - The state.
       * @returns {string} The key used to reference the view object in the viewData config
       *  object.
       */
      getViewKey: function (state) {
        var viewKey = 'admin';
        angular.forEach(this.viewMap, function (value, key) {
          if (value.indexOf(state) !== -1) {
            viewKey = key;
          }
        });
        return viewKey;
      },

      /**
       * Resets the view data for the specified state by removing the previous data.
       *
       * @param {String} state - The state.
       */
      resetState: function (state) {
        var key = this.getViewKey(state);
        this.resetKey(key);
      },

      /**
       * Resets the view data for the specified key by removing the previous data.
       *
       * @param {String} key - The view key.
       */
      resetKey: function (key) {
        var data = this.viewData[key];
        data.previous = null;
        data.previousParams = null;
      }
    };
  });
